import { array } from 'fp-ts';
import { notNil } from '../utils';

export const compactArray = array.filter(notNil);
